const translations = {
    aircraftAffected: 'Aircraft Affected',
    dateOfIncident: 'Date of Incident',
    descriptionOfDamage: 'Description of Damage',
    faaReferenceNumber: 'FAA Reference Number'
};

export default translations;
